<template>
  <div v-if="variants.v1 === variant && property">
    <section class="n-section-primary !tw-pb-0 !tw-pt-36" style="background-color: #eaf3f3">
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
        </div>
        <div class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h2 class="tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>
            <template v-if="!property.is_locked">
              <div class="tw-mt-3 tw-flex tw-items-center tw-gap-1 tw-pb-4">
                <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.944 3.25H13.056C14.894 3.25 16.35 3.25 17.489 3.403C18.661 3.561 19.61 3.893 20.359 4.641C21.107 5.39 21.439 6.339 21.597 7.511C21.748 8.637 21.75 10.071 21.75 11.879C22.094 12.162 22.367 12.529 22.54 12.948C22.661 13.238 22.708 13.538 22.73 13.855C22.75 14.159 22.75 14.53 22.75 14.975V15.025C22.75 15.47 22.75 15.841 22.73 16.145C22.7171 16.4557 22.6529 16.7622 22.54 17.052C22.4019 17.3857 22.1994 17.689 21.9441 17.9445C21.6888 18.2 21.3857 18.4027 21.052 18.541C20.762 18.661 20.462 18.708 20.145 18.729C20.0135 18.7378 19.8818 18.7434 19.75 18.746V20C19.75 20.1989 19.671 20.3897 19.5303 20.5303C19.3897 20.671 19.1989 20.75 19 20.75C18.8011 20.75 18.6103 20.671 18.4697 20.5303C18.329 20.3897 18.25 20.1989 18.25 20V18.75H5.75V20C5.75 20.1989 5.67098 20.3897 5.53033 20.5303C5.38968 20.671 5.19891 20.75 5 20.75C4.80109 20.75 4.61032 20.671 4.46967 20.5303C4.32902 20.3897 4.25 20.1989 4.25 20V18.745C4.11823 18.7428 3.98652 18.7374 3.855 18.729C3.54438 18.7167 3.23791 18.6532 2.948 18.541C2.61416 18.4028 2.31082 18.2002 2.05533 17.9447C1.79984 17.6892 1.5972 17.3858 1.459 17.052C1.339 16.762 1.292 16.462 1.271 16.145C1.25 15.841 1.25 15.47 1.25 15.025V14.975C1.25 14.53 1.25 14.159 1.27 13.855C1.292 13.537 1.34 13.238 1.46 12.948C1.63182 12.5321 1.90308 12.1647 2.25 11.878C2.25 10.072 2.252 8.637 2.403 7.511C2.561 6.339 2.893 5.39 3.641 4.641C4.39 3.893 5.339 3.561 6.511 3.403C7.651 3.25 9.106 3.25 10.944 3.25ZM3.75 11.279C4.08288 11.2575 4.41643 11.2478 4.75 11.25V10.448C4.75 9.55 4.75 8.8 4.83 8.206C4.914 7.578 5.1 7.011 5.555 6.556C6.011 6.1 6.578 5.914 7.205 5.83C7.8 5.75 8.55 5.75 9.448 5.75H14.552C15.451 5.75 16.2 5.75 16.794 5.83C17.422 5.914 17.989 6.1 18.444 6.555C18.9 7.011 19.086 7.578 19.17 8.205C19.25 8.8 19.25 9.55 19.25 10.448V11.25C19.5836 11.2478 19.9171 11.2575 20.25 11.279C20.247 9.744 20.23 8.604 20.11 7.711C19.975 6.705 19.721 6.125 19.298 5.701C18.875 5.279 18.295 5.025 17.289 4.89C16.262 4.752 14.907 4.75 13 4.75H11C9.093 4.75 7.739 4.752 6.71 4.89C5.705 5.025 5.125 5.279 4.702 5.702C4.279 6.125 4.025 6.705 3.89 7.711C3.77 8.604 3.753 9.744 3.75 11.279ZM17.75 11.25V10.5C17.75 9.536 17.748 8.888 17.683 8.405C17.621 7.944 17.514 7.746 17.383 7.616C17.253 7.486 17.056 7.379 16.595 7.316C16.112 7.252 15.464 7.25 14.5 7.25H12.75V11.25H17.75ZM11.25 11.25V7.25H9.5C8.536 7.25 7.888 7.252 7.405 7.317C6.944 7.379 6.746 7.486 6.616 7.617C6.486 7.747 6.379 7.944 6.316 8.405C6.252 8.888 6.25 9.536 6.25 10.5V11.25H11.25ZM3.957 12.767C3.716 12.784 3.599 12.813 3.522 12.845C3.3702 12.9078 3.23228 12.9999 3.11611 13.1161C2.99995 13.2323 2.90782 13.3702 2.845 13.522C2.813 13.599 2.784 13.716 2.767 13.957C2.75 14.204 2.75 14.524 2.75 15C2.75 15.476 2.75 15.796 2.767 16.043C2.784 16.284 2.813 16.401 2.845 16.478C2.972 16.785 3.215 17.028 3.522 17.155C3.599 17.187 3.716 17.216 3.957 17.233C4.204 17.25 4.524 17.25 5 17.25H19C19.476 17.25 19.796 17.25 20.043 17.233C20.284 17.216 20.401 17.187 20.478 17.155C20.785 17.028 21.028 16.785 21.155 16.478C21.187 16.401 21.216 16.284 21.233 16.043C21.25 15.796 21.25 15.476 21.25 15C21.25 14.524 21.25 14.204 21.233 13.957C21.216 13.716 21.187 13.599 21.155 13.522C21.0922 13.3702 21.0001 13.2323 20.8839 13.1161C20.7677 12.9999 20.6298 12.9078 20.478 12.845C20.401 12.813 20.284 12.784 20.043 12.767C19.6956 12.7507 19.3478 12.745 19 12.75H5C4.524 12.75 4.204 12.75 3.957 12.767Z"
                        fill="#6EADAB"
                      />
                    </svg>
                    <p>Beds: {{ property.bedroom }}</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_428_289)">
                        <path
                          d="M2.25 13.1243H20.25V4.68677C20.2509 4.36902 20.1887 4.05425 20.0671 3.76069C19.9455 3.46712 19.7669 3.2006 19.5416 2.97653L19.5228 2.95778C19.1697 2.60521 18.7164 2.37024 18.2248 2.28499C17.7331 2.19973 17.2271 2.26834 16.776 2.48144C17.2021 3.1899 17.3792 4.02046 17.2791 4.84112C17.1791 5.66178 16.8077 6.42547 16.2239 7.01083L15.7105 7.52416L16.6554 8.46906L15.5948 9.52966L14.6499 8.5848L9.41451 3.34947L8.46966 2.40461L9.5303 1.34397L10.4752 2.28883L10.9885 1.7755C11.6031 1.16263 12.4133 0.784826 13.2778 0.707939C14.1424 0.631052 15.0065 0.859952 15.7196 1.35475C16.4715 0.879867 17.3627 0.674856 18.2465 0.773397C19.1304 0.871937 19.9545 1.26817 20.5834 1.897L20.6022 1.91575C20.9672 2.2788 21.2566 2.71064 21.4536 3.18629C21.6507 3.66193 21.7514 4.17193 21.75 4.68677V13.1243H23.25V14.6243H21.75V16.0633C21.75 16.1842 21.7305 16.3044 21.6923 16.4191L20.2969 20.605C20.2224 20.8291 20.0792 21.0241 19.8877 21.1621C19.6961 21.3002 19.4659 21.3745 19.2297 21.3743H18.625L19.1719 23.2493H17.6094L17.0625 21.3743H7.30781L6.74531 23.2493H5.17969L5.74219 21.3743H4.77047C4.53428 21.3745 4.30403 21.3003 4.11242 21.1622C3.92081 21.0241 3.7776 20.8291 3.70312 20.605L2.30784 16.4191C2.26956 16.3044 2.25002 16.1842 2.25 16.0633V14.6243H0.75V13.1243H2.25ZM15.1631 2.83614C14.7499 2.42379 14.1899 2.19221 13.6061 2.19221C13.0224 2.19221 12.4624 2.42379 12.0492 2.83614L11.5359 3.34947L14.6498 6.46333L15.1631 5.9501C15.5755 5.53684 15.807 4.9769 15.807 4.39312C15.807 3.80934 15.5755 3.2494 15.1631 2.83614ZM3.75 16.0024L5.04056 19.8743H18.9594L20.25 16.0024V14.6243H3.75V16.0024Z"
                          fill="#6EADAB"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_428_289">
                          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                        </clipPath>
                      </defs>
                    </svg>

                    <p>Baths: {{ property.bathroom }}</p>
                  </div>
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21 9V7C21 5.35 19.65 4 18 4H14C13.23 4 12.53 4.3 12 4.78C11.47 4.3 10.77 4 10 4H6C4.35 4 3 5.35 3 7V9C1.35 9 0 10.35 0 12V17C0 18.65 1.35 20 3 20V22H5V20H19V22H21V20C22.65 20 24 18.65 24 17V12C24 10.35 22.65 9 21 9ZM14 6H18C18.55 6 19 6.45 19 7V9.78C18.39 10.33 18 11.12 18 12V14H13V7C13 6.45 13.45 6 14 6ZM5 7C5 6.45 5.45 6 6 6H10C10.55 6 11 6.45 11 7V14H6V12C6 11.12 5.61 10.33 5 9.78V7ZM22 17C22 17.55 21.55 18 21 18H3C2.45 18 2 17.55 2 17V12C2 11.45 2.45 11 3 11C3.55 11 4 11.45 4 12V16H20V12C20 11.45 20.45 11 21 11C21.55 11 22 11.45 22 12V17Z"
                        fill="#6EADAB"
                      />
                    </svg>
                    <p>Receptions: {{ property.reception }}</p>
                  </div>
                </div>
              </div>
            </template>
            <div class="tw-mt-2 tw-flex tw-items-center tw-gap-1">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="var(--c-primary)"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="var(--c-primary)"
                />
              </svg>
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-py-16 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-py-24"
            :class="{ 'tw-py-4': property.is_locked }"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <template v-if="!property.is_locked">
                <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
              </template>

              <button class="n-secondary" @click="onShared()">SHARE</button>
            </div>
            <div class="tw-pt-6">
              <div v-if="property.price">
                <p v-if="property.price.type.name">
                  {{ property.price.type.name }}
                </p>
                <h5 class="!tw-text-3xl" style="color: var(--c-primary)">
                  {{ property.price.price }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="n-section-primary !tw-pt-0" style="background-color: #eaf3f3">
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div
          class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8"
          :class="{ 'lg:!tw-col-span-12 xl:!tw-col-span-7': property.is_locked }"
        >
          <div class="tw-grid tw-w-full tw-grid-cols-8 tw-gap-1">
            <!-- GALLERY START -->
            <div class="property-detail-image-container tw-relative tw-col-span-6 tw-flex tw-flex-col lg:tw-col-span-6">
              <library-image
                :src="property.image"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[0])"
                :title="property.advert_heading"
                :w-ratio="3"
                :h-ratio="2"
                image-class="tw-h-full"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <div class="nc-first-image-overlay-item">
                <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                  1/{{ property.medias.length }}
                </div>
              </div>
            </div>
            <div class="tw-col-span-2 tw-flex tw-flex-col tw-gap-1 lg:tw-col-span-2">
              <library-image
                :src="primaryFourPhotos[1].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[1])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[2].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[2])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[3].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[3])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[4].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[4])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
            <!-- GALLERY END -->
          </div>

          <!-- Property Detail -->
          <div v-if="!property.is_locked" class="tw-flex tw-flex-col tw-gap-16">
            <!-- Property Video -->
            <div v-if="property?.featured_video">
              <h3 class="tw-pb-8">Property Video</h3>
              <library-video-embed :video-url="propertyVideo(property?.featured_video.mediaLink)" :is-popup="true" />
            </div>
            <!-- Features -->
            <div>
              <h3>Features</h3>
              <div class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                </div>
              </div>
            </div>

            <!-- Property Info -->
            <div v-if="property.description">
              <h3 class="tw-pb-4">Property Info</h3>
              <div v-html="property.description"></div>
            </div>

            <!-- Floor Plan -->
            <div v-if="property.floor_plans">
              <h3>Floor Plans</h3>
              <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
            </div>

            <!-- Map -->
            <div v-if="property.map_position && property.map_position.lat && property.map_position.lng">
              <h3 class="tw-pb-8">Map</h3>
              <neuron-google-map
                v-model:map-center-position="property.map_position"
                :component="component"
                :marker-color="markerColor"
              />
            </div>

            <!-- Amenties -->
            <library-properties-property-criteria-list :property="property" class="tw-mt-8" main-list-title="Amenties">
              <template #list-item="{ criteria }">
                <div style="">
                  <h5 class="tw-pb-2">{{ criteria.title }}</h5>

                  <div
                    class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                    style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
                  >
                    <svg width="28" height="28" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_726_237)">
                        <path
                          d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                          fill="var(--c-primary)"
                        />
                        <path
                          d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                          fill="var(--c-primary)"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_726_237">
                          <rect width="54" height="54" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <div class="tw-flex tw-flex-col">
                      <p>{{ criteria.value }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </library-properties-property-criteria-list>

            <!-- EPC -->
            <div v-if="property.epc">
              <h3 class="tw-pb-8">EPC</h3>

              <epc :data="property.epcs" :component="component" />
            </div>
          </div>
          <template v-else> </template>
        </div>
        <template v-if="!property.is_locked">
          <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
            <div v-if="sidebarComponents && sidebarComponents.length">
              <popup
                v-if="property?.virtual_tour?.mediaLink && virtualTourPopupConfig.isActive"
                :config="virtualTourPopupConfig"
                custom-width="40%"
                class="!tw-z-50"
              >
                <template #content>
                  <iframe
                    class="video"
                    width="100%"
                    height="460"
                    :src="propertyVideo(property?.virtual_tour?.mediaLink)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </template>
              </popup>
              <div v-if="property" class="tw-bg-white tw-px-6 tw-py-9 lg:tw-px-8 lg:tw-py-12">
                <h3 class="tw-pb-7">Viewing Options</h3>
                <div class="tw-flex tw-flex-col tw-gap-4">
                  <button
                    v-if="property?.virtual_tour?.mediaLink"
                    @click="showVideoTourPopup()"
                    class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                  >
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                        fill="white"
                      />
                    </svg>

                    VIDEO TOUR
                  </button>
                  <button @click="onSendLead()" class="n-primary">BOOK A VIEWING</button>
                </div>
              </div>
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </template>
        <template v-else-if="property.is_locked">
          <library-login />
        </template>
      </div>
      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
  </div>

  <div v-if="variants.v2 === variant" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <section
      class="n-section-primary !tw-pb-0 !tw-pt-44"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-mb-14 tw-flex tw-w-full tw-pl-5 md:tw-pl-8">
        <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
      </div>
      <div class="tw-grid tw-w-full tw-grid-cols-12 xl:tw-grid-cols-11 xl:tw-gap-x-16">
        <div
          class="tw-col-span-12 tw-mb-6 tw-grid tw-w-full tw-grid-cols-12 tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-p-8 xl:tw-col-span-6 xl:tw-mb-0"
          style="border-radius: var(--rounded)"
        >
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-8">
            <h3 class="n-title-primary">Gallery</h3>
            <!-- GALLERY START -->
            <MotionGroup
              is="div"
              preset="slideVisibleBottom"
              :duration="700"
              class="tw-flex tw-w-full tw-cursor-pointer tw-flex-col tw-gap-1 xl:tw-flex-row xl:tw-gap-2"
            >
              <div class="tw-relative tw-flex tw-w-full">
                <library-image
                  :src="property.image"
                  alt="property first image"
                  @click="onClickedImage(primaryFourPhotos[0])"
                  :title="property.advert_heading"
                  :w-ratio="3"
                  :h-ratio="2"
                  image-class="tw-h-full"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </div>
              <div class="tw-relative tw-flex tw-gap-1 xl:tw-h-full xl:tw-w-[45%] xl:tw-flex-col xl:tw-gap-2">
                <library-image
                  :src="primaryFourPhotos[1].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[1])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <library-image
                  :src="primaryFourPhotos[2].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[2])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <button
                  class="tw-absolute tw-bottom-2 tw-right-0 tw-bg-white tw-uppercase tw-text-[var(--c-secondary)] xl:tw-right-1"
                  @click="onClickedImage(primaryFourPhotos[2])"
                >
                  View more
                </button>
              </div>
            </MotionGroup>
            <!-- GALLERY END -->
          </div>
        </div>
        <div
          v-if="property?.featured_video"
          class="tw-col-span-12 tw-grid tw-w-full tw-grid-cols-12 tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-p-8 xl:tw-col-span-5"
          style="border-radius: var(--rounded)"
        >
          <h3 class="n-title-primary tw-col-span-12 tw-pb-8">Walkthrough Video</h3>
          <div
            class="video-landscape tw-col-span-12 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
            style="border-radius: var(--rounded)"
          >
            <library-iframe
              :src="propertyVideo(property?.featured_video.mediaLink)"
              :w-ratio="16"
              :h-ratio="9"
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            />
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="property"
      class="n-section-primary !tw-pb-10 !tw-pt-5 xl:!tw-pb-14"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <MotionGroup is="div" class="tw-flex tw-flex-col" preset="fadeVisible" :duration="700">
        <div
          class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between tw-px-4 tw-py-6 lg:tw-items-start lg:tw-p-8"
        >
          <div
            class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7"
            :class="property.is_locked ? 'lg:!tw-col-span-12 xl:!tw-col-span-7' : ''"
          >
            <h2 class="n-title-primary tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>

            <div class="tw-mt-6">
              <p v-if="property.price.type.name" class="tw-mb-0">
                {{ property.price.type.name }}
              </p>
              <h4>{{ property.price.price }}</h4>
            </div>

            <div class="tw-mt-5 tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="black"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="black"
                />
              </svg>
              <small>{{ property.display_address }}</small>
            </div>

            <div v-if="!property.is_locked" class="tw-mt-6 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
              <div v-if="property.bedroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 19V13C2 12.55 2.09167 12.1417 2.275 11.775C2.45833 11.4083 2.7 11.0833 3 10.8V8C3 7.16667 3.29167 6.45833 3.875 5.875C4.45833 5.29167 5.16667 5 6 5H10C10.3833 5 10.7417 5.071 11.075 5.213C11.4083 5.355 11.7167 5.55067 12 5.8C12.2833 5.55 12.5917 5.35433 12.925 5.213C13.2583 5.07167 13.6167 5.00067 14 5H18C18.8333 5 19.5417 5.29167 20.125 5.875C20.7083 6.45833 21 7.16667 21 8V10.8C21.3 11.0833 21.5417 11.4083 21.725 11.775C21.9083 12.1417 22 12.55 22 13V19H20V17H4V19H2ZM13 10H19V8C19 7.71667 18.904 7.47933 18.712 7.288C18.52 7.09667 18.2827 7.00067 18 7H14C13.7167 7 13.4793 7.096 13.288 7.288C13.0967 7.48 13.0007 7.71733 13 8V10ZM5 10H11V8C11 7.71667 10.904 7.47933 10.712 7.288C10.52 7.09667 10.2827 7.00067 10 7H6C5.71667 7 5.47933 7.096 5.288 7.288C5.09667 7.48 5.00067 7.71733 5 8V10ZM4 15H20V13C20 12.7167 19.904 12.4793 19.712 12.288C19.52 12.0967 19.2827 12.0007 19 12H5C4.71667 12 4.47933 12.096 4.288 12.288C4.09667 12.48 4.00067 12.7173 4 13V15Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bedroom }} Beds</small
                >
              </div>
              <div v-if="property.bathroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V14C1.99996 14.9783 2.23913 15.9417 2.69665 16.8064C3.15417 17.671 3.81618 18.4107 4.625 18.961L4.293 19.293C4.19749 19.3852 4.12131 19.4956 4.0689 19.6176C4.01649 19.7396 3.9889 19.8708 3.98775 20.0036C3.9866 20.1364 4.0119 20.2681 4.06218 20.391C4.11246 20.5138 4.18671 20.6255 4.2806 20.7194C4.3745 20.8133 4.48615 20.8875 4.60905 20.9378C4.73194 20.9881 4.86362 21.0134 4.9964 21.0123C5.12918 21.0111 5.2604 20.9835 5.3824 20.9311C5.50441 20.8787 5.61475 20.8025 5.707 20.707L6.583 19.832C7.037 19.942 7.512 20 8 20H16C16.488 20 16.963 19.942 17.417 19.832L18.293 20.707C18.4816 20.8892 18.7342 20.99 18.9964 20.9877C19.2586 20.9854 19.5094 20.8802 19.6948 20.6948C19.8802 20.5094 19.9854 20.2586 19.9877 19.9964C19.99 19.7342 19.8892 19.4816 19.707 19.293L19.375 18.961C20.1838 18.4107 20.8458 17.671 21.3034 16.8064C21.7609 15.9417 22 14.9783 22 14V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H7V6ZM4 13H20V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V13Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bathroom }} Baths</small
                >
              </div>
              <div v-if="property.reception">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.556 18H18.444C19.3871 18 20.2916 17.6254 20.9585 16.9585C21.6254 16.2916 22 15.3871 22 14.444V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 10 20 10C19.4696 10 18.9609 10.2107 18.5858 10.5858C18.2107 10.9609 18 11.4696 18 12V13.2C18 13.4122 17.9157 13.6157 17.7657 13.7657C17.6157 13.9157 17.4122 14 17.2 14H6.8C6.58783 14 6.38434 13.9157 6.23431 13.7657C6.08429 13.6157 6 13.4122 6 13.2V12C6 11.4696 5.78929 10.9609 5.41421 10.5858C5.03914 10.2107 4.53043 10 4 10C3.46957 10 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V14.444C2 15.3871 2.37465 16.2916 3.04153 16.9585C3.70841 17.6254 4.61289 18 5.556 18Z"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path
                        d="M20 10C20 9.07 20 8.606 19.923 8.22C19.7687 7.44401 19.3877 6.73121 18.8282 6.17175C18.2688 5.6123 17.556 5.23132 16.78 5.077C16.394 5 15.93 5 15 5H9C8.07 5 7.606 5 7.22 5.077C6.44401 5.23132 5.73121 5.6123 5.17175 6.17175C4.6123 6.73121 4.23132 7.44401 4.077 8.22C4 8.606 4 9.07 4 10"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path d="M20 19V18M4 19V18" stroke="#074873" stroke-width="2" stroke-linecap="round" />
                    </svg> </span
                  >{{ property.reception }} Reception</small
                >
              </div>
              <div v-if="property.floor_area">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V5C21 3.897 20.103 3 19 3H5C3.897 3 3 3.897 3 5ZM19.002 19H5V5H19L19.002 19Z"
                        fill="#074873"
                      />
                      <path d="M15 12H17V7H12V9H15V12ZM12 15H9V12H7V17H12V15Z" fill="#074873" />
                    </svg> </span
                  >{{ property.floor_area }}</small
                >
              </div>
            </div>
          </div>
          <div
            v-if="!property.is_locked"
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-pt-0"
          >
            <div class="tw-flex tw-w-full tw-items-center tw-justify-between lg:tw-justify-end lg:tw-gap-8">
              <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
            </div>
          </div>

          <template v-if="property.is_locked">
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-col-span-5 xl:tw-pt-0"
            >
              <library-login />
            </div>
          </template>
        </div>
      </MotionGroup>
    </section>

    <section
      v-if="!property.is_locked"
      class="n-section-primary !tw-pt-0"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
          <!-- Property Detail -->
          <div class="tw-flex tw-flex-col tw-gap-16">
            <!-- Features -->
            <MotionGroup
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
              preset="fadeVisible"
              :duration="800"
              is="div"
            >
              <h3 class="n-title-primary !tw-opacity-100">Features</h3>
              <div class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <library-text class="tw-text-base" :text="feature"> </library-text>
                </div>
              </div>
            </MotionGroup>

            <!-- Floor Plan -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.floor_plans"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Floor Plans</h3>
              <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
            </MotionGroup>

            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property?.virtual_tour"
              id="matterport_video"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Matterport Video</h3>
              <library-iframe :src="matterPort" />
            </MotionGroup>

            <!-- Property Info -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.description"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Property Info</h3>
              <div v-html="property.description"></div>
              <div class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6">
                <div
                  v-for="criteria in property.criteria_list"
                  :key="criteria.id"
                  class="tw-flex tw-gap-4 tw-p-4"
                  style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                >
                  <span v-if="criteria.title === 'Parking'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Sewerage'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Water'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>
                  <span v-else>
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_481_37820)">
                        <path
                          d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                          fill="#EB2123"
                        />
                        <path
                          d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                          fill="#EB2123"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_481_37820">
                          <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <div>
                    <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                    <p>{{ criteria.value }}</p>
                  </div>
                </div>
              </div>
            </MotionGroup>

            <!-- Map -->
            <div
              v-if="property.map_position && property.map_position.lat && property.map_position.lng"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Map</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <neuron-google-map
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </MotionGroup>
            </div>

            <!-- EPC -->
            <div
              v-if="property?.epcs.length > 0"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">EPC</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <epc :data="property.epcs" :component="component" />
              </MotionGroup>
            </div>
          </div>
        </div>

        <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
          <div v-if="sidebarComponents && sidebarComponents.length">
            <popup
              v-if="property?.virtual_tour?.mediaLink && virtualTourPopupConfig.isActive"
              :config="virtualTourPopupConfig"
              custom-width="90%"
              class="!tw-z-50"
            >
              <template #content>
                <iframe
                  class="video"
                  width="100%"
                  height="460"
                  :src="propertyVideo(property?.virtual_tour?.mediaLink)"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </template>
            </popup>
            <popup
              v-if="property?.featured_video?.mediaLink && videoTourPopupConfig.isActive"
              :config="videoTourPopupConfig"
              custom-width="90%"
              class="!tw-z-50"
            >
              <template #content>
                <iframe
                  class="video tw-aspect-video tw-h-[200px] tw-justify-self-center md:tw-h-[400px]"
                  :src="propertyVideo(property?.featured_video?.mediaLink)"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </template>
            </popup>
            <div v-if="property" class="tw-bg-white tw-px-6 tw-py-9 lg:tw-px-8 lg:tw-py-12">
              <h3 class="n-title-primary tw-pb-7">Viewing Options</h3>
              <div class="tw-flex tw-flex-col tw-gap-4">
                <button
                  v-if="property?.featured_video?.mediaLink"
                  @click="showVideoTourPopup2()"
                  class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-mb-1"
                  >
                    <path
                      d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                      fill="white"
                    />
                  </svg>

                  VIDEO TOUR
                </button>
                <button
                  v-if="property?.virtual_tour?.mediaLink"
                  @click="showVideoTourPopup()"
                  class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-mb-1"
                  >
                    <path
                      d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                      fill="white"
                    />
                  </svg>

                  360 TOUR
                </button>
                <button @click="onSendLead()" class="n-primary">BOOK A VIEWING</button>
              </div>
            </div>
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
      </div>
      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
  </div>

  <div v-if="variants.v3 === variant" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <section
      v-if="property"
      class="n-section-primary tw-hidden lg:tw-flex lg:!tw-pb-0 lg:!tw-pt-44"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-mb-14 tw-flex tw-w-full tw-pl-5 md:tw-pl-8 lg:tw-block">
        <library-properties-back-to-all-properties-navbar color="var(--c-secondary)" class="tw-uppercase" />
      </div>
      <MotionGroup is="div" class="tw-flex tw-flex-col" preset="fadeVisible" :duration="700">
        <div
          class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between tw-px-4 tw-py-6 lg:tw-items-start lg:tw-p-8"
        >
          <div
            class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7"
            :class="property.is_locked ? 'lg:!tw-col-span-12 xl:!tw-col-span-7' : ''"
          >
            <h2 class="n-title-primary tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>

            <div class="tw-mt-6">
              <p v-if="property.price.type.name" class="tw-mb-0">
                {{ property.price.type.name }}
              </p>
              <h4>{{ property.price.price }}</h4>
            </div>

            <div class="tw-mt-5 tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="black"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="black"
                />
              </svg>
              <small>{{ property.display_address }}</small>
            </div>

            <div v-if="!property.is_locked" class="tw-mt-6 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
              <div v-if="property.bedroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 19V13C2 12.55 2.09167 12.1417 2.275 11.775C2.45833 11.4083 2.7 11.0833 3 10.8V8C3 7.16667 3.29167 6.45833 3.875 5.875C4.45833 5.29167 5.16667 5 6 5H10C10.3833 5 10.7417 5.071 11.075 5.213C11.4083 5.355 11.7167 5.55067 12 5.8C12.2833 5.55 12.5917 5.35433 12.925 5.213C13.2583 5.07167 13.6167 5.00067 14 5H18C18.8333 5 19.5417 5.29167 20.125 5.875C20.7083 6.45833 21 7.16667 21 8V10.8C21.3 11.0833 21.5417 11.4083 21.725 11.775C21.9083 12.1417 22 12.55 22 13V19H20V17H4V19H2ZM13 10H19V8C19 7.71667 18.904 7.47933 18.712 7.288C18.52 7.09667 18.2827 7.00067 18 7H14C13.7167 7 13.4793 7.096 13.288 7.288C13.0967 7.48 13.0007 7.71733 13 8V10ZM5 10H11V8C11 7.71667 10.904 7.47933 10.712 7.288C10.52 7.09667 10.2827 7.00067 10 7H6C5.71667 7 5.47933 7.096 5.288 7.288C5.09667 7.48 5.00067 7.71733 5 8V10ZM4 15H20V13C20 12.7167 19.904 12.4793 19.712 12.288C19.52 12.0967 19.2827 12.0007 19 12H5C4.71667 12 4.47933 12.096 4.288 12.288C4.09667 12.48 4.00067 12.7173 4 13V15Z"
                        fill="var(--c-primary)"
                      />
                    </svg> </span
                  >{{ property.bedroom }} Beds</small
                >
              </div>
              <div v-if="property.bathroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V14C1.99996 14.9783 2.23913 15.9417 2.69665 16.8064C3.15417 17.671 3.81618 18.4107 4.625 18.961L4.293 19.293C4.19749 19.3852 4.12131 19.4956 4.0689 19.6176C4.01649 19.7396 3.9889 19.8708 3.98775 20.0036C3.9866 20.1364 4.0119 20.2681 4.06218 20.391C4.11246 20.5138 4.18671 20.6255 4.2806 20.7194C4.3745 20.8133 4.48615 20.8875 4.60905 20.9378C4.73194 20.9881 4.86362 21.0134 4.9964 21.0123C5.12918 21.0111 5.2604 20.9835 5.3824 20.9311C5.50441 20.8787 5.61475 20.8025 5.707 20.707L6.583 19.832C7.037 19.942 7.512 20 8 20H16C16.488 20 16.963 19.942 17.417 19.832L18.293 20.707C18.4816 20.8892 18.7342 20.99 18.9964 20.9877C19.2586 20.9854 19.5094 20.8802 19.6948 20.6948C19.8802 20.5094 19.9854 20.2586 19.9877 19.9964C19.99 19.7342 19.8892 19.4816 19.707 19.293L19.375 18.961C20.1838 18.4107 20.8458 17.671 21.3034 16.8064C21.7609 15.9417 22 14.9783 22 14V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H7V6ZM4 13H20V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V13Z"
                        fill="var(--c-primary)"
                      />
                    </svg> </span
                  >{{ property.bathroom }} Baths</small
                >
              </div>
              <div v-if="property.reception">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.556 18H18.444C19.3871 18 20.2916 17.6254 20.9585 16.9585C21.6254 16.2916 22 15.3871 22 14.444V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 10 20 10C19.4696 10 18.9609 10.2107 18.5858 10.5858C18.2107 10.9609 18 11.4696 18 12V13.2C18 13.4122 17.9157 13.6157 17.7657 13.7657C17.6157 13.9157 17.4122 14 17.2 14H6.8C6.58783 14 6.38434 13.9157 6.23431 13.7657C6.08429 13.6157 6 13.4122 6 13.2V12C6 11.4696 5.78929 10.9609 5.41421 10.5858C5.03914 10.2107 4.53043 10 4 10C3.46957 10 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V14.444C2 15.3871 2.37465 16.2916 3.04153 16.9585C3.70841 17.6254 4.61289 18 5.556 18Z"
                        stroke="var(--c-primary)"
                        stroke-width="2"
                      />
                      <path
                        d="M20 10C20 9.07 20 8.606 19.923 8.22C19.7687 7.44401 19.3877 6.73121 18.8282 6.17175C18.2688 5.6123 17.556 5.23132 16.78 5.077C16.394 5 15.93 5 15 5H9C8.07 5 7.606 5 7.22 5.077C6.44401 5.23132 5.73121 5.6123 5.17175 6.17175C4.6123 6.73121 4.23132 7.44401 4.077 8.22C4 8.606 4 9.07 4 10"
                        stroke="var(--c-primary)"
                        stroke-width="2"
                      />
                      <path d="M20 19V18M4 19V18" stroke="var(--c-primary)" stroke-width="2" stroke-linecap="round" />
                    </svg> </span
                  >{{ property.reception }} Reception</small
                >
              </div>
              <div v-if="property.floor_area">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V5C21 3.897 20.103 3 19 3H5C3.897 3 3 3.897 3 5ZM19.002 19H5V5H19L19.002 19Z"
                        fill="var(--c-primary)"
                      />
                      <path d="M15 12H17V7H12V9H15V12ZM12 15H9V12H7V17H12V15Z" fill="var(--c-primary)" />
                    </svg> </span
                  >{{ property.floor_area }}</small
                >
              </div>
            </div>
          </div>
          <div
            v-if="!property.is_locked"
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-pt-0"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between md:tw-justify-start md:tw-gap-3 lg:tw-justify-end lg:tw-gap-8"
            >
              <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
              <button class="n-secondary" @click="onShared()">SHARE</button>
            </div>
          </div>

          <template v-if="property.is_locked">
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-col-span-5 xl:tw-pt-0"
            >
              <library-login />
            </div>
          </template>
        </div>
      </MotionGroup>
    </section>
    <section
      class="n-section-primary !tw-pb-0 !tw-pt-44 lg:!tw-pt-10"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-mb-14 tw-flex tw-w-full tw-pl-5 md:tw-pl-8 lg:tw-hidden">
        <library-properties-back-to-all-properties-navbar color="var(--c-secondary)" class="tw-uppercase" />
      </div>
      <div class="tw-grid tw-w-full tw-grid-cols-12 xl:tw-grid-cols-11 xl:tw-gap-x-16">
        <div
          class="tw-col-span-12 tw-mb-6 tw-grid tw-w-full tw-grid-cols-12 tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-bg-transparent lg:tw-p-0"
          style="border-radius: var(--rounded)"
        >
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-8">
            <h3 class="n-title-primary lg:tw-hidden">Photo Gallery</h3>
            <!-- GALLERY START -->
            <MotionGroup
              is="div"
              preset="slideVisibleBottom"
              :duration="700"
              class="tw-flex tw-w-full tw-cursor-pointer tw-flex-col tw-gap-1 lg:tw-hidden xl:tw-flex-row xl:tw-gap-2"
            >
              <div class="tw-relative tw-flex tw-w-full">
                <library-image
                  :src="property.image"
                  alt="property first image"
                  @click="onClickedImage(primaryFourPhotos[0])"
                  :title="property.advert_heading"
                  :w-ratio="3"
                  :h-ratio="2"
                  image-class="tw-h-full"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </div>
              <div class="tw-relative tw-flex tw-gap-1 xl:tw-h-full xl:tw-w-[45%] xl:tw-flex-col xl:tw-gap-2">
                <library-image
                  :src="primaryFourPhotos[1].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[1])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <library-image
                  :src="primaryFourPhotos[2].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[2])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <button
                  class="tw-absolute tw-bottom-2 tw-right-2 tw-bg-white tw-uppercase tw-text-[var(--c-secondary)] xl:tw-right-1"
                  @click="onClickedImage(primaryFourPhotos[2])"
                >
                  View more
                </button>
              </div>
            </MotionGroup>

            <div class="tw-relative tw-hidden tw-w-full lg:tw-block">
              <div class="tw-absolute -tw-top-[90px] tw-right-[50px] tw-z-10">
                <span
                  ><svg width="179" height="142" viewBox="0 0 179 142" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_60_19288)">
                      <path
                        d="M80.0532 74.816C80.0255 74.816 79.9978 74.816 79.97 74.8022C78.9446 74.6359 77.9053 74.5667 76.8522 74.6082C76.7275 74.6082 76.5889 74.6082 76.4642 74.6221C76.4226 74.6221 76.3672 74.6221 76.3256 74.6221C67.9282 75.204 60.1821 82.7964 58.2282 93.2845C58.2282 93.2845 58.2282 93.2984 58.2282 93.3122C58.2698 93.3538 58.2975 93.3954 58.3391 93.4369C58.4084 93.5062 58.4499 93.5893 58.5054 93.6586C59.8911 95.7368 58.2698 99.062 56.3991 100.531C56.3714 100.544 56.3575 100.572 56.3298 100.586C56.2882 100.614 56.2605 100.641 56.2189 100.669C56.1912 100.697 56.1635 100.711 56.1219 100.738C54.5699 101.791 51.0225 101.597 51.7847 104.258C52.0341 105.144 52.8517 105.421 53.8909 105.311C53.9325 105.311 53.9879 105.311 54.0295 105.297C54.0849 105.297 54.1404 105.283 54.1958 105.269C54.3344 105.241 54.4729 105.214 54.6254 105.172C54.6947 105.158 54.7639 105.13 54.8332 105.117H54.8471C54.9164 105.103 54.9718 105.075 55.0411 105.061C55.0688 105.061 55.0965 105.047 55.1242 105.033C55.2074 105.006 55.3044 104.978 55.3875 104.936C55.4152 104.936 55.4291 104.923 55.4568 104.909C55.5261 104.881 55.5954 104.853 55.6508 104.826C55.7894 104.77 55.9279 104.701 56.0665 104.645L54.3482 106.447C54.2512 106.447 54.1542 106.447 54.0572 106.447C53.9879 106.447 53.9187 106.447 53.8494 106.419C53.7801 106.419 53.7108 106.405 53.6415 106.377C53.5722 106.377 53.5168 106.35 53.4475 106.336C53.4059 106.336 53.3782 106.322 53.3367 106.308C53.1011 106.239 52.8655 106.156 52.6299 106.059C52.6161 106.059 52.5884 106.045 52.5745 106.031C52.1311 105.851 51.7708 105.657 51.6045 105.588C51.5768 105.574 51.5491 105.56 51.5352 105.56C51.5352 105.56 51.4937 105.56 51.4659 105.588C51.2997 105.657 50.9394 105.851 50.4959 106.031C50.4682 106.031 50.4544 106.045 50.4405 106.059C50.2049 106.156 49.9694 106.239 49.7338 106.308C49.6922 106.308 49.6507 106.336 49.6229 106.336C49.5675 106.35 49.4982 106.363 49.4289 106.377C49.3597 106.391 49.2904 106.405 49.2211 106.419C49.1518 106.419 49.0825 106.433 49.0132 106.447C48.9162 106.447 48.8192 106.447 48.7222 106.447L47.0039 104.645C47.1425 104.715 47.2811 104.77 47.4197 104.826C47.4889 104.853 47.5582 104.881 47.6137 104.909C47.6414 104.909 47.6552 104.923 47.6829 104.936C47.7661 104.978 47.8631 105.006 47.9462 105.033C47.9739 105.033 48.0017 105.047 48.0294 105.061C48.0987 105.075 48.1541 105.103 48.2234 105.117C48.2234 105.117 48.2234 105.117 48.2372 105.117C48.3065 105.13 48.3758 105.158 48.4451 105.172C48.5837 105.214 48.7361 105.241 48.8747 105.269C48.9301 105.269 48.9855 105.283 49.0409 105.297C49.0964 105.297 49.1379 105.311 49.1795 105.311C50.2049 105.421 51.0364 105.144 51.2858 104.258C52.0479 101.597 48.5005 101.805 46.9485 100.738C46.9208 100.711 46.8792 100.697 46.8515 100.669C46.8099 100.641 46.7822 100.614 46.7407 100.586C46.7129 100.572 46.6991 100.544 46.6714 100.531C44.8007 99.062 43.1794 95.7368 44.5651 93.6586C44.6205 93.5755 44.6759 93.5062 44.7314 93.4369C44.7729 93.3954 44.8007 93.3538 44.8422 93.3122C44.8422 93.3122 44.8422 93.2984 44.8422 93.2845C42.8884 82.7964 35.1422 75.204 26.7448 74.6221C26.7033 74.6221 26.6478 74.6221 26.6063 74.6221C26.4815 74.6221 26.343 74.6082 26.2183 74.6082C25.1651 74.5667 24.1258 74.6498 23.1004 74.8022C23.0727 74.8022 23.045 74.8022 23.0173 74.816C14.4536 76.2154 7.428 83.8355 8.14857 85.6782C8.14857 85.6782 8.14857 85.6921 8.14857 85.7059C8.38414 86.2463 9.32643 86.2186 10.5736 86.3294C16.3243 86.842 20.3844 89.419 25.4423 92.6472C28.1167 94.3514 29.2391 95.5844 30.223 96.8452C31.5394 98.5355 32.6064 100.254 36.819 103.218C42.348 107.098 46.3388 108.22 48.9994 108.691C49.5398 108.788 50.3574 108.913 51.3967 108.996V109.024C51.4659 109.024 51.5214 109.024 51.5768 109.024C51.6322 109.024 51.7015 109.024 51.7569 109.024V108.996C52.7824 108.913 53.6138 108.788 54.1542 108.691C56.8148 108.22 60.8195 107.098 66.3346 103.218C70.5472 100.254 71.6142 98.5355 72.9306 96.8452C73.9145 95.5844 75.0369 94.3513 77.7113 92.6334C82.7692 89.4052 86.8293 86.8143 92.58 86.3156C93.8272 86.2047 94.7556 86.2324 95.005 85.6921C95.005 85.6921 95.005 85.6782 95.005 85.6644C95.7117 83.8217 88.7 76.2015 80.1363 74.8022L80.0532 74.816Z"
                        fill="white"
                      />
                      <path
                        d="M95.0729 82.0206C94.3246 80.0117 93.6733 77.975 93.0359 75.9245C91.7887 71.8235 90.694 67.6809 89.2806 63.6353C88.6847 61.9034 87.7147 59.4788 87.2159 58.121C87.1743 57.9964 87.105 57.8578 87.0357 57.7054C86.9942 57.6223 86.9387 57.5253 86.8972 57.4283C86.8694 57.3729 86.8279 57.3175 86.8002 57.262C86.7724 57.2205 86.7586 57.1789 86.7309 57.1374C86.6893 57.0542 86.6339 56.9711 86.5923 56.888C86.523 56.7633 86.4399 56.6247 86.3567 56.4862C86.2597 56.3061 86.1489 56.126 86.038 55.9458C86.0103 55.8904 85.9826 55.835 85.9549 55.7796C85.8856 55.6687 85.8302 55.5579 85.7609 55.4332C85.7055 55.3362 85.6639 55.2392 85.6084 55.1423C85.5392 55.0037 85.4699 54.879 85.4145 54.7405C85.3729 54.6296 85.3175 54.5326 85.2759 54.4218C85.2343 54.311 85.1927 54.214 85.1512 54.1031C85.1096 53.9923 85.068 53.8815 85.0403 53.7706C84.9572 53.5212 84.5415 53.1472 84.3197 52.2189C83.6269 50.8473 82.4629 49.7112 82.1026 48.1594C81.4375 46.6077 77.405 43.4488 77.114 42.3404C77.0863 42.2157 77.0725 42.091 77.0725 41.9802C77.0725 41.8693 77.0725 41.9248 77.0725 41.897C77.0725 41.8832 77.0725 41.8555 77.0725 41.8416C77.0725 41.8139 77.0725 41.7862 77.0725 41.7585C77.0725 41.7169 77.0863 41.6892 77.1002 41.6477C77.114 41.6061 77.1279 41.5784 77.1417 41.5368C77.1417 41.523 77.1556 41.4953 77.1695 41.4814C77.2249 41.3844 77.2803 41.2874 77.3496 41.2043C77.3912 41.1627 77.4189 41.1212 77.4605 41.0935C77.502 41.0519 77.5436 41.0103 77.5852 40.9688C77.6129 40.9411 77.6406 40.9134 77.6683 40.8995C77.696 40.8718 77.7237 40.8579 77.7376 40.8302C77.7792 40.7887 77.8207 40.7471 77.8762 40.7055C77.9732 40.6224 78.0702 40.5254 78.1672 40.4284C78.2087 40.3869 78.2503 40.3314 78.3057 40.2899C78.3889 40.1929 78.472 40.0821 78.5413 39.9712C78.5552 39.9435 78.569 39.9158 78.5967 39.8881C78.6383 39.805 78.6799 39.708 78.7215 39.5971C78.6937 39.5971 78.6799 39.611 78.6522 39.6249C78.6245 39.6249 78.6106 39.6526 78.5829 39.6526C78.5413 39.6803 78.4997 39.6941 78.4582 39.7218C78.3473 39.7773 78.2226 39.8327 78.1117 39.8881C78.0009 39.9435 77.89 39.9851 77.793 40.0266C77.6406 40.0959 77.4882 40.1513 77.3496 40.2068C77.308 40.2206 77.2526 40.2483 77.211 40.2622C77.1556 40.2899 77.1002 40.3037 77.0309 40.3314C76.9755 40.3453 76.92 40.373 76.8646 40.3869C76.8092 40.4007 76.7537 40.4284 76.6983 40.4423C76.6567 40.4423 76.6152 40.47 76.5597 40.4839C76.5182 40.4839 76.4766 40.4977 76.435 40.5116C76.3796 40.5116 76.338 40.5393 76.2826 40.5393C76.2272 40.5393 76.1717 40.5531 76.1163 40.567C76.0747 40.567 76.0332 40.567 75.9916 40.5808C74.4396 40.7332 74.1486 39.4586 72.1948 38.3364C72.0423 38.2532 71.876 38.1562 71.7236 38.0593C71.5573 37.9623 71.4049 37.8791 71.2386 37.7822C70.906 37.602 70.5873 37.4219 70.2548 37.2418C66.4302 35.1774 60.6656 32.3788 56.4254 31.6583C56.3976 31.6583 56.1205 31.6306 55.8433 31.6029C54.4854 31.4228 53.0719 31.3258 51.6446 31.2981C51.5892 31.2981 51.5199 31.2981 51.4645 31.2981C51.4091 31.2981 51.3398 31.2981 51.2844 31.2981C49.8571 31.3397 48.4436 31.4366 47.0856 31.6168C46.8085 31.6583 46.5314 31.6722 46.5037 31.6722C42.2634 32.3926 36.4988 35.1913 32.6742 37.2557C32.3555 37.4219 32.023 37.602 31.6904 37.796C31.5241 37.893 31.3578 37.9761 31.2054 38.0731C31.0391 38.1701 30.8867 38.2532 30.7342 38.3502C28.7942 39.4863 28.4894 40.7471 26.9374 40.5947C26.8958 40.5947 26.8542 40.5947 26.8127 40.5808C26.7572 40.5808 26.7018 40.567 26.6464 40.5531C26.591 40.5531 26.5494 40.5393 26.494 40.5254C26.4524 40.5254 26.4108 40.5116 26.3692 40.4977C26.3277 40.4977 26.2861 40.47 26.2307 40.4561C26.1752 40.4423 26.1198 40.4284 26.0644 40.4007C26.009 40.3869 25.9535 40.3592 25.8981 40.3453C25.8427 40.3314 25.7872 40.3037 25.718 40.276C25.6764 40.2622 25.6348 40.2345 25.5794 40.2206C25.4408 40.1652 25.2884 40.1098 25.136 40.0405C25.039 39.9989 24.9281 39.9435 24.8172 39.9019C24.7064 39.8465 24.5955 39.7911 24.4708 39.7357C24.4293 39.7218 24.3877 39.6941 24.3461 39.6664C24.3322 39.6664 24.3045 39.6526 24.2768 39.6387C24.2491 39.6387 24.2352 39.611 24.2075 39.611C24.2352 39.7218 24.2768 39.805 24.3323 39.9019C24.3461 39.9297 24.36 39.9574 24.3877 39.9851C24.457 40.0959 24.5401 40.2068 24.6232 40.3037C24.6648 40.3453 24.7064 40.4007 24.7618 40.4423C24.8588 40.5393 24.9558 40.6224 25.0528 40.7194C25.0944 40.7609 25.136 40.8025 25.1914 40.8441C25.2191 40.8718 25.2468 40.8856 25.2607 40.9133C25.2884 40.9411 25.3161 40.9549 25.3438 40.9826C25.3854 41.0242 25.427 41.0658 25.4685 41.1073C25.5101 41.1489 25.5378 41.1904 25.5794 41.2182C25.6487 41.3013 25.718 41.3983 25.7595 41.4953C25.7595 41.523 25.7872 41.5368 25.7872 41.5645C25.8011 41.6061 25.815 41.6338 25.8288 41.6754C25.8427 41.7169 25.8565 41.7446 25.8565 41.7862C25.8565 41.8139 25.8565 41.8416 25.8565 41.8693C25.8565 41.8832 25.8565 41.9109 25.8565 41.9248C25.8565 41.9525 25.8565 41.9802 25.8565 42.0079C25.8565 42.1187 25.8427 42.2434 25.815 42.3681C25.524 43.4765 21.4915 46.6215 20.8264 48.1871C20.4661 49.7389 19.3021 50.875 18.6093 52.2466C18.3875 53.1749 17.9718 53.549 17.8887 53.7983C17.8471 53.9092 17.8194 54.02 17.7778 54.1309C17.7363 54.2417 17.6947 54.3387 17.6531 54.4495C17.6115 54.5604 17.5561 54.6712 17.5145 54.7682C17.4453 54.9067 17.3898 55.0453 17.3205 55.17C17.2651 55.267 17.2235 55.3639 17.1681 55.4609C17.1127 55.5718 17.0434 55.6965 16.9741 55.8073C16.9464 55.8627 16.9187 55.9181 16.891 55.9736C16.7801 56.1537 16.6831 56.3338 16.5723 56.5139C16.4891 56.6524 16.406 56.7771 16.3367 56.9157C16.2813 56.9988 16.2397 57.0819 16.1981 57.1651C16.1704 57.2066 16.1565 57.2482 16.1288 57.2898C16.1011 57.3452 16.0595 57.4006 16.0318 57.456C15.9764 57.553 15.9348 57.65 15.8933 57.7331C15.824 57.8717 15.7547 58.0102 15.7131 58.1488C15.2143 59.5065 14.2443 61.9311 13.6484 63.663C12.235 67.7086 11.1403 71.8512 9.89313 75.9522C9.26956 78.0027 8.61827 80.0394 7.85613 82.0483C7.56513 82.8242 6.4427 83.7663 6.69213 84.6392C6.76142 84.8609 7.37113 85.7476 7.77299 85.8169C7.85613 85.8307 7.93927 85.8169 8.00856 85.7337C8.00856 85.7199 8.03627 85.706 8.05013 85.6922C12.6646 79.1942 17.8471 75.7305 22.8773 74.8438C22.905 74.8438 22.9327 74.8438 22.9604 74.83C24.0135 74.6499 25.0528 74.5806 26.0782 74.636C26.203 74.636 26.3415 74.636 26.4662 74.6499C34.3094 75.1902 41.3488 82.0206 44.7161 93.3262C44.7161 93.3262 44.7161 93.3262 44.7161 93.34C44.7577 93.2985 44.7992 93.2569 44.8269 93.2153C46.0602 91.9961 48.6238 91.3172 51.2428 91.3034C51.2982 91.3034 51.3675 91.3034 51.4229 91.3034C51.4784 91.3034 51.5476 91.3034 51.6031 91.3034C54.2221 91.3034 56.7856 91.9823 58.0189 93.2153C58.0605 93.2569 58.1021 93.2985 58.1298 93.34C58.1298 93.34 58.1298 93.34 58.1298 93.3262C61.4971 82.0206 68.5365 75.1902 76.3796 74.6499C76.5043 74.6499 76.6429 74.636 76.7676 74.636C77.793 74.5944 78.8323 74.6499 79.8855 74.83C79.9132 74.83 79.9409 74.83 79.9686 74.8438C84.9987 75.7305 90.1674 79.1804 94.7957 85.6783C94.7957 85.6922 94.8234 85.706 94.8373 85.7199C94.9066 85.7892 94.9759 85.8169 95.0729 85.803C95.4886 85.7337 96.0983 84.847 96.1537 84.6253C96.4032 83.7525 95.2807 82.8104 94.9897 82.0345L95.0729 82.0206Z"
                        fill="#F27021"
                      />
                      <path
                        d="M89.295 63.6352C88.6991 61.9034 87.7291 59.4788 87.2303 58.121C92.1773 46.2336 93.8956 32.7113 92.1218 19.9371C91.8308 17.8173 90.4036 11.1531 89.392 9.50441C89.3227 9.39357 89.5167 8.52072 88.7546 8.54843C82.1724 14.9632 78.3617 23.7749 74.648 32.0878C73.7473 34.0967 72.8743 36.175 72.2369 38.3086C71.6133 37.9484 70.9343 37.5604 70.2969 37.2141C71.2946 27.9175 73.6364 19.4245 79.1377 11.8043C81.1054 9.07491 84.0293 6.71959 86.1217 4.15645L91.4151 0C91.8586 1.14995 92.5514 2.27219 92.9671 3.40829C94.6023 7.70329 96.0296 15.4897 96.5146 20.1172C98.0111 34.831 96.4314 50.584 89.2811 63.6352H89.295Z"
                        fill="#292417"
                      />
                      <path
                        d="M87.2168 58.121C86.8288 57.0819 85.6093 55.5717 85.0273 53.7706C85.5955 54.0061 85.9003 52.9393 86.0389 52.5513C91.1106 38.7658 88.5748 23.8164 89.3785 9.50439C90.3901 11.1531 91.8173 17.8173 92.1083 19.9371C93.8821 32.7112 92.1499 46.2335 87.2168 58.121Z"
                        fill="white"
                      />
                      <path
                        d="M86.0536 52.5514C85.9151 52.9393 85.5964 54.0061 85.0421 53.7706C84.9589 53.5212 84.5432 53.1471 84.3215 52.2189C83.6286 50.8472 82.4646 49.7111 82.1044 48.1594C81.4392 46.6077 77.4068 43.4488 77.1158 42.3404C76.7832 40.9965 78.3491 40.7886 78.7371 39.5694C74.4552 41.7446 74.9818 39.8881 72.252 38.2948C72.8894 36.1611 73.7624 34.0967 74.6631 32.0739C78.3768 23.7749 82.1875 14.9632 88.7696 8.53458C89.5179 8.50687 89.3378 9.37973 89.4071 9.49056C88.6034 23.8026 91.1253 38.7381 86.0675 52.5375L86.0536 52.5514Z"
                        fill="#D94512"
                      />
                      <path
                        d="M68.1901 62.887C68.0239 62.8593 67.8714 62.8178 67.719 62.8039C65.682 62.4714 63.6173 62.8039 62.0514 64.2171C61.9821 64.2864 61.9129 64.3418 61.8436 64.4111C61.8436 64.4111 61.8159 64.4249 61.8159 64.4388C61.7604 64.4942 61.705 64.5496 61.6634 64.605C60.7766 65.5472 60.1391 66.6417 59.6819 67.8055C59.0999 69.288 58.8089 70.8951 58.6426 72.4884C62.2177 72.8348 67.913 75.3702 71.017 72.3222C74.218 69.1771 72.5967 63.8292 68.1763 62.9009L68.1901 62.887ZM60.5271 68.5537C60.8181 65.7827 65.1277 63.081 67.7051 64.5912C67.5804 64.7436 66.5273 65.2147 66.4441 65.4918C65.585 67.8609 68.4673 69.1771 69.6867 66.8634C72.763 74.3588 59.8204 75.2594 60.541 68.5537H60.5271Z"
                        fill="white"
                      />
                      <path
                        d="M71.0176 72.2945C74.2186 69.1495 72.5973 63.8015 68.1769 62.8732C63.798 61.9588 61.2206 63.9678 59.7102 67.8748L59.4746 67.2514C64.5047 53.4242 80.4543 64.6189 71.0176 72.2945Z"
                        fill="#292417"
                      />
                      <path
                        d="M60.5282 68.5537C60.8192 65.7827 65.1426 63.081 67.7062 64.5912C67.5814 64.7436 66.5283 65.2147 66.4313 65.4918C65.5722 67.8609 68.4544 69.1771 69.6739 66.8634C72.7501 74.3588 59.8076 75.2594 60.5143 68.5537H60.5282Z"
                        fill="#292417"
                      />
                      <path
                        d="M97.8858 87.6318C102.154 91.2341 103.83 97.5242 102.597 102.886C102.445 103.537 101.835 106.031 101.655 106.461C101.364 107.126 99.4239 110.298 98.9112 110.797C97.8303 111.85 94.6848 112.709 93.1189 112.903C93.9642 111.642 94.9896 101.182 92.4399 101.75C91.5253 101.958 93.1189 111.684 90.6524 112.889C88.4075 112.695 87.3405 112.46 85.2065 111.684C86.2042 108.137 88.9064 105.2 86.6476 101.39C84.2088 100.877 86.0102 104.161 85.6499 105.685C85.2065 107.555 84.0425 109.218 83.0725 110.825C80.9385 109.855 80.4951 109.328 78.7352 108.082C79.7191 106.253 83.9039 95.5429 79.4558 97.7459C79.9962 101.071 78.4304 103.967 77.2109 106.973C74.0238 104.147 72.6381 102.886 72.8182 98.2723C72.8598 97.067 72.7489 96.1664 73.1647 94.9472C73.5804 93.7418 74.2871 92.7581 74.9661 91.719C79.9962 83.9187 90.5554 81.4387 97.8858 87.6318Z"
                        fill="#F27021"
                      />
                      <path
                        d="M93.1189 112.903C91.8163 113.055 91.8995 113 90.6523 112.903C93.1051 111.684 91.5115 101.958 92.4399 101.764C95.0035 101.196 93.9642 111.656 93.1189 112.917V112.903Z"
                        fill="#292621"
                      />
                      <path
                        d="M78.7508 108.082C78.1273 107.638 77.8917 107.569 77.2266 106.973C78.446 103.967 80.0118 101.071 79.4714 97.7458C83.9334 95.5568 79.7486 106.253 78.7508 108.082Z"
                        fill="#292621"
                      />
                      <path
                        d="M85.208 111.684C84.5013 111.421 83.7669 111.13 83.0879 110.825C84.0579 109.218 85.2219 107.555 85.6653 105.685C86.0256 104.161 84.2242 100.877 86.663 101.39C88.9217 105.2 86.2196 108.137 85.2219 111.684H85.208Z"
                        fill="#292621"
                      />
                      <path
                        d="M49.5527 105.615C49.6636 105.574 49.7606 105.532 49.8714 105.477C49.7744 105.532 49.6636 105.574 49.5527 105.615Z"
                        fill="#1D1D1B"
                      />
                      <path
                        d="M13.7051 63.6352C14.3009 61.9034 15.2709 59.4788 15.7698 58.121C10.8228 46.2336 9.10449 32.7113 10.8782 19.9371C11.1692 17.8173 12.5965 11.1531 13.6081 9.50441C13.6773 9.39357 13.4833 8.52072 14.2455 8.54843C20.8276 14.9632 24.6383 23.7749 28.352 32.0878C29.2527 34.0967 30.1257 36.175 30.7632 38.3086C31.3867 37.9484 32.0657 37.5604 32.7032 37.2141C31.7055 27.9175 29.3636 19.4245 23.8623 11.8043C21.8946 9.07491 18.9708 6.71959 16.8783 4.15645L11.5711 0C11.1276 1.14995 10.4348 2.27219 10.0191 3.40829C8.38392 7.70329 6.95663 15.4897 6.47163 20.1172C4.97507 34.831 6.55478 50.584 13.7051 63.6352Z"
                        fill="#292417"
                      />
                      <path
                        d="M59.4064 102.027C59.3648 102.082 59.3232 102.138 59.2817 102.207C59.2401 102.249 59.2124 102.304 59.1708 102.346C59.1292 102.401 59.0877 102.457 59.0322 102.498C58.8937 102.65 58.7412 102.817 58.5749 102.955C58.5195 103.011 58.4641 103.052 58.4087 103.108C58.2978 103.205 58.1731 103.302 58.0622 103.399C58.0068 103.44 57.9375 103.496 57.8821 103.537C57.8821 103.537 57.8821 103.537 57.8682 103.551C57.8128 103.593 57.7574 103.634 57.7019 103.676C57.4387 103.87 57.1477 104.05 56.8567 104.23C56.7735 104.285 56.6765 104.327 56.5934 104.382C56.5102 104.424 56.4132 104.479 56.3301 104.521C56.3301 104.521 56.3024 104.521 56.2885 104.535C56.2192 104.576 56.1499 104.604 56.0807 104.632C56.0807 104.632 56.0807 104.632 56.0668 104.632C55.9282 104.701 55.7897 104.756 55.6511 104.812C55.5818 104.84 55.5125 104.867 55.4571 104.895C55.4294 104.895 55.4155 104.909 55.3878 104.923C55.3047 104.964 55.2077 104.992 55.1245 105.02C55.0968 105.02 55.0691 105.034 55.0414 105.047C54.9721 105.061 54.9167 105.089 54.8474 105.103C54.8474 105.103 54.8474 105.103 54.8335 105.103C54.7642 105.117 54.6949 105.144 54.6257 105.158C54.4871 105.2 54.3347 105.227 54.1961 105.255C54.1407 105.255 54.0852 105.269 54.0298 105.283C53.9744 105.283 53.9328 105.297 53.8912 105.297C52.8658 105.408 52.0344 105.13 51.7849 104.244C51.7434 104.091 51.7157 103.953 51.7018 103.814V103.316C51.9374 101.611 54.7919 101.639 56.1361 100.725C56.1638 100.697 56.2054 100.683 56.2331 100.655C56.2747 100.628 56.3024 100.6 56.3439 100.572C56.3717 100.558 56.3855 100.531 56.4132 100.517C58.2839 99.0482 60.0299 95.82 58.5195 93.6448C58.4641 93.5617 58.4087 93.4924 58.3532 93.4232C58.3117 93.3816 58.2839 93.34 58.2424 93.2985C58.2008 93.2569 58.1592 93.2153 58.1315 93.1738C56.8705 91.913 54.2099 91.2479 51.5355 91.2618C48.8611 91.2341 46.2005 91.913 44.9395 93.1738C44.898 93.2153 44.8564 93.2569 44.8287 93.2985C44.7871 93.34 44.7594 93.3816 44.7178 93.4232C44.6485 93.4924 44.607 93.5756 44.5515 93.6448C43.0411 95.82 44.7871 99.0482 46.6578 100.517C46.6855 100.531 46.6994 100.558 46.7271 100.572C46.7687 100.6 46.7964 100.628 46.838 100.655C46.8657 100.683 46.8934 100.697 46.935 100.725C48.2791 101.639 51.1198 101.611 51.3692 103.316V103.814C51.3554 103.953 51.3277 104.091 51.2861 104.244C51.0367 105.13 50.2191 105.408 49.1798 105.297C49.1382 105.297 49.0828 105.297 49.0412 105.283C48.9858 105.283 48.9304 105.269 48.875 105.255C48.7364 105.227 48.5978 105.2 48.4454 105.158C48.3761 105.144 48.3068 105.117 48.2375 105.103H48.2237C48.1544 105.089 48.099 105.061 48.0297 105.047C48.002 105.047 47.9742 105.034 47.9465 105.02C47.8634 104.992 47.7664 104.964 47.6832 104.923C47.6555 104.923 47.6417 104.909 47.614 104.895C47.5447 104.867 47.4754 104.84 47.42 104.812C47.2814 104.756 47.1428 104.687 47.0042 104.632C47.0042 104.632 47.0042 104.632 46.9904 104.632C46.9211 104.604 46.8518 104.562 46.7825 104.535C46.7825 104.535 46.7548 104.535 46.741 104.521C46.6578 104.479 46.5608 104.424 46.4777 104.382C46.3945 104.341 46.2975 104.285 46.2144 104.23C45.9234 104.064 45.6324 103.884 45.3691 103.676C45.3137 103.634 45.2582 103.593 45.2028 103.551C45.2028 103.551 45.2028 103.551 45.189 103.537C45.1197 103.496 45.0642 103.44 45.0088 103.399C44.8841 103.302 44.7732 103.205 44.6624 103.108C44.607 103.066 44.5515 103.011 44.4961 102.955C44.3298 102.803 44.1774 102.65 44.0388 102.498C43.9972 102.443 43.9418 102.387 43.9002 102.346C43.8587 102.304 43.8171 102.249 43.7894 102.207C43.7478 102.152 43.7062 102.096 43.6647 102.027C43.5538 101.875 43.3182 101.999 43.3875 102.166C44.2467 104.258 46.8934 106.391 48.7364 106.447C48.8334 106.447 48.9304 106.447 49.0274 106.447C49.0967 106.447 49.1659 106.447 49.2352 106.419C49.3045 106.391 49.3738 106.405 49.4431 106.377C49.5124 106.377 49.5678 106.35 49.6371 106.336C49.6787 106.336 49.7064 106.322 49.748 106.308C49.9835 106.239 50.2191 106.156 50.4547 106.059C50.4685 106.059 50.4962 106.045 50.5101 106.031C50.7595 105.92 51.1059 105.671 51.3831 105.588V105.657C51.3831 105.657 51.3969 105.657 51.4108 105.643C51.4801 105.602 51.5217 105.574 51.5494 105.56C51.5494 105.56 51.5494 105.56 51.5632 105.56C51.5632 105.56 51.5632 105.56 51.5771 105.56C51.6048 105.56 51.6464 105.588 51.7157 105.643C51.7157 105.643 51.7295 105.643 51.7434 105.657V105.588C52.0344 105.671 52.3669 105.92 52.6164 106.031C52.6441 106.031 52.6579 106.045 52.6718 106.059C52.9074 106.156 53.1429 106.239 53.3785 106.308C53.4201 106.308 53.4617 106.336 53.4894 106.336C53.5448 106.35 53.6141 106.364 53.6834 106.377C53.7527 106.391 53.8219 106.405 53.8912 106.419C53.9605 106.433 54.0298 106.433 54.0991 106.447C54.1961 106.447 54.2931 106.447 54.3901 106.447C56.2331 106.391 58.8798 104.258 59.7389 102.166C59.8082 101.985 59.5727 101.861 59.4618 102.027H59.4064Z"
                        fill="#292417"
                      />
                      <path
                        d="M15.7688 58.121C16.1568 57.0819 17.3763 55.5717 17.9583 53.7706C17.3901 54.0061 17.0853 52.9393 16.9467 52.5513C11.875 38.7658 14.4108 23.8164 13.6071 9.50439C12.5955 11.1531 11.1683 17.8173 10.8773 19.9371C9.10355 32.7112 10.8357 46.2335 15.7688 58.121Z"
                        fill="white"
                      />
                      <path
                        d="M16.9472 52.5514C17.0857 52.9393 17.4045 54.0061 17.9587 53.7706C18.0419 53.5212 18.4576 53.1471 18.6793 52.2189C19.3722 50.8472 20.5362 49.7111 20.8965 48.1594C21.5616 46.6077 25.594 43.4488 25.885 42.3404C26.2176 40.9965 24.6517 40.7886 24.2637 39.5694C28.5456 41.7446 28.019 39.8881 30.7489 38.2948C30.1114 36.1611 29.2384 34.0967 28.3377 32.0739C24.624 23.7749 20.8133 14.9632 14.2312 8.53458C13.4829 8.50687 13.663 9.37973 13.5938 9.49056C14.3975 23.8026 11.8755 38.7381 16.9333 52.5375L16.9472 52.5514Z"
                        fill="#D94512"
                      />
                      <path
                        d="M34.8081 62.887C34.9744 62.8593 35.1268 62.8178 35.2793 62.8039C37.3163 62.4714 39.381 62.8039 40.9468 64.2171C41.0161 64.2864 41.0854 64.3418 41.1547 64.4111C41.1547 64.4111 41.1824 64.4249 41.1824 64.4388C41.2378 64.4942 41.2933 64.5496 41.3348 64.605C42.2217 65.5472 42.8591 66.6417 43.3164 67.8055C43.8984 69.288 44.1894 70.8951 44.3557 72.4884C40.7805 72.8348 35.0853 75.3702 31.9813 72.3222C28.7803 69.1771 30.4016 63.8292 34.822 62.9009L34.8081 62.887ZM42.4711 68.5537C42.1801 65.7827 37.8705 63.081 35.2931 64.5912C35.4178 64.7436 36.471 65.2147 36.5541 65.4918C37.4133 67.8609 34.531 69.1771 33.3115 66.8634C30.2353 74.3588 43.1778 75.2594 42.4573 68.5537H42.4711Z"
                        fill="white"
                      />
                      <path
                        d="M31.9678 72.2945C28.7668 69.1495 30.3881 63.8015 34.8085 62.8732C39.1874 61.9588 41.7648 63.9678 43.2752 67.8748L43.5108 67.2514C38.4807 53.4242 22.5311 64.6189 31.9678 72.2945Z"
                        fill="#292417"
                      />
                      <path
                        d="M42.4729 68.5537C42.1819 65.7827 37.8584 63.081 35.2949 64.5912C35.4196 64.7436 36.4727 65.2147 36.5697 65.4918C37.4289 67.8609 34.5466 69.1771 33.3272 66.8634C30.2509 74.3588 43.1934 75.2594 42.4867 68.5537H42.4729Z"
                        fill="#292417"
                      />
                      <path
                        d="M5.0987 87.6318C0.83071 91.2341 -0.846002 97.5242 0.387282 102.886C0.539711 103.537 1.14942 106.031 1.32957 106.461C1.62057 107.126 3.56056 110.298 4.07328 110.797C5.15413 111.85 8.2997 112.709 9.86555 112.903C9.02027 111.642 7.99484 101.182 10.5446 101.75C11.4591 101.958 9.86555 111.684 12.3321 112.889C14.577 112.695 15.644 112.46 17.778 111.684C16.7803 108.137 14.0781 105.2 16.3368 101.39C18.7757 100.877 16.9743 104.161 17.3345 105.685C17.778 107.555 18.942 109.218 19.912 110.825C22.046 109.855 22.4894 109.328 24.2492 108.082C23.2654 106.253 19.0805 95.5429 23.5287 97.7459C22.9883 101.071 24.5541 103.967 25.7735 106.973C28.9607 104.147 30.3464 102.886 30.1662 98.2723C30.1247 97.067 30.2355 96.1664 29.8198 94.9472C29.4041 93.7418 28.6974 92.7581 28.0184 91.719C22.9883 83.9187 12.4291 81.4387 5.0987 87.6318Z"
                        fill="#F27021"
                      />
                      <path
                        d="M9.87982 112.903C11.1824 113.055 11.0992 113 12.3464 112.903C9.89368 111.684 11.4872 101.958 10.5588 101.764C7.99525 101.196 9.03454 111.656 9.87982 112.917V112.903Z"
                        fill="#292621"
                      />
                      <path
                        d="M24.2503 108.082C24.8739 107.638 25.1095 107.569 25.7746 106.973C24.5552 103.967 22.9893 101.071 23.5298 97.7458C19.0678 95.5568 23.2526 106.253 24.2503 108.082Z"
                        fill="#292621"
                      />
                      <path
                        d="M17.7928 111.684C18.4995 111.421 19.2339 111.13 19.9129 110.825C18.9429 109.218 17.7789 107.555 17.3355 105.685C16.9752 104.161 18.7766 100.877 16.3378 101.39C14.0791 105.2 16.7812 108.137 17.7789 111.684H17.7928Z"
                        fill="#292621"
                      />
                      <path
                        d="M53.4476 105.615C53.3368 105.574 53.2398 105.532 53.1289 105.477C53.2259 105.532 53.3368 105.574 53.4476 105.615Z"
                        fill="#1D1D1B"
                      />
                    </g>
                    <g clip-path="url(#clip1_60_19288)">
                      <path
                        d="M134.451 111.741L131.16 115.57L136.969 117.039L133.819 121.404C137.443 122.369 140.876 123.252 136.487 126.784L138.158 127.65C134.384 127.213 124.976 130.274 121.568 132.238C116.922 134.92 116.157 136.901 113.506 141.092C113.298 141.422 113.157 141.909 112.642 141.992C112.01 138.6 112.342 134.681 113.215 131.331C116.274 119.597 125.042 116.824 134.443 111.725"
                        fill="#F0E8CC"
                      />
                      <path
                        d="M138.158 127.659C138.374 127.683 138.557 127.766 138.773 127.824C142.047 128.657 140.053 130.324 139.612 132.568C130.702 134.12 120.064 133.946 113.506 141.109C116.157 136.917 116.922 134.937 121.568 132.255C124.976 130.291 134.384 127.221 138.158 127.667"
                        fill="#D6D1AD"
                      />
                      <path
                        d="M166.383 116.247C164.131 118.227 161.637 119.943 159.011 121.379C153.5 124.399 147.408 126.256 141.224 127.419C139.579 127.733 137.626 127.906 136.47 126.701C137.077 126.297 137.709 125.876 138.108 125.266C138.507 124.655 138.623 123.797 138.191 123.219C137.958 122.906 137.601 122.716 137.252 122.543C136.163 122.015 134.999 121.627 133.802 121.404C134.849 119.943 135.905 118.491 136.952 117.031C135.016 116.544 133.079 116.049 131.143 115.562C131.807 114.613 132.888 113.202 134.434 111.725C136.994 109.282 138.315 109.051 140.967 107.038C143.485 105.124 146.544 102.805 147.957 99.1576C148.555 97.6228 149.91 93.1422 150.375 91.9127C150.4 91.8467 150.492 91.6074 150.583 91.2691C150.758 90.6089 150.799 90.0808 150.824 89.8003C150.899 88.7523 150.799 87.6879 150.658 86.6482C150.458 85.1629 150.159 83.6446 149.311 82.4151C148.464 81.1773 146.934 80.2944 145.463 80.608C144.341 80.8473 143.468 81.7219 142.754 82.6214C140.593 85.3526 139.321 88.6533 138.157 91.9209C137.526 91.9209 136.894 91.9209 136.271 91.9209C137.684 85.79 140.884 79.7993 146.195 76.3749C149.835 74.0397 154.224 73.0495 158.545 73C162.269 72.9587 166.051 73.6189 169.359 75.3187C172.667 77.0185 175.468 79.8241 176.756 83.2897C177.545 85.4104 177.753 87.7044 177.77 89.9653C177.82 96.5583 176.224 103.217 172.741 108.828C171.013 111.609 168.843 114.085 166.383 116.255V116.247Z"
                        fill="#F57826"
                      />
                      <path
                        d="M178.992 93.4558C178.992 93.8601 178.975 94.2727 178.967 94.677C178.884 99.7848 177.695 104.859 175.783 109.563C174.969 110.421 174.055 112.839 173.248 114.019C164.887 126.215 153.675 130.109 139.595 132.568C140.036 130.332 142.031 128.665 138.756 127.824C148.755 126.239 158.712 123.038 166.367 116.255C175.576 108.094 179.058 96.6739 177.288 84.577C178.327 87.3991 178.917 90.4274 178.975 93.4475"
                        fill="#DB6624"
                      />
                      <path
                        d="M150.899 89.2804C150.882 89.627 150.849 89.9653 150.799 90.2706C150.758 90.5347 150.708 90.7822 150.658 90.9803C150.575 91.3433 150.5 91.5744 150.5 91.5744C150.458 91.6982 150.425 91.8137 150.384 91.921H138.008C139.246 85.559 141.947 80.9215 145.206 80.4595C145.721 80.3852 146.203 80.4264 146.602 80.5007C146.835 80.542 147.042 80.5997 147.209 80.6492C147.508 80.74 147.699 80.8308 147.716 80.839C150.566 82.2336 151.007 86.4914 150.891 89.2804H150.899Z"
                        fill="#D94512"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_60_19288">
                        <rect width="103" height="113" fill="white" />
                      </clipPath>
                      <clipPath id="clip1_60_19288">
                        <rect width="76" height="69" fill="white" transform="translate(103 73)" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </div>
              <Swiper
                :modules="[SwiperNavigation]"
                :slides-per-view="1"
                :space-between="1"
                :loop="true"
                effect="fade"
                :clickable="true"
                :navigation="{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }"
                class="tw-relative tw-w-full"
                @swiper="onSwiper"
              >
                <SwiperSlide v-for="(item, index) in allPhotos" :key="index" class="tw-relative tw-w-full">
                  <library-image
                    image-class="tw-w-full"
                    :src="item.background"
                    :h-ratio="9"
                    :w-ratio="16"
                    @click="onClickedImage(item)"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  />
                  <div v-if="property && property.medias" class="tw-absolute tw-bottom-2 tw-right-2">
                    <div
                      style="
                        border-radius: var(--rounded-sm);
                        color: var(--c-primary);
                        background-color: var(--c-section_primary);
                      "
                      @click="onClickedImage(item)"
                      class="tw-text-md tw-px-2 tw-py-1"
                    >
                      {{ index + 1 }}/{{ property.medias.length }}
                    </div>
                  </div>
                </SwiperSlide>

                <div class="tw-flex tw-items-center tw-justify-between">
                  <div class="swiper-button-prev tw-cursor-pointer tw-rounded-full tw-bg-white tw-p-4">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.0107 3.4995C16.1416 3.63344 16.2148 3.81326 16.2148 4.0005C16.2148 4.18775 16.1416 4.36756 16.0107 4.5015L8.70125 12L16.0107 19.497C16.1416 19.6309 16.2148 19.8108 16.2148 19.998C16.2148 20.1852 16.1416 20.3651 16.0107 20.499C15.9472 20.5643 15.8711 20.6162 15.7871 20.6517C15.7031 20.6871 15.6129 20.7054 15.5217 20.7054C15.4306 20.7054 15.3403 20.6871 15.2564 20.6517C15.1724 20.6162 15.0963 20.5643 15.0327 20.499L7.25975 12.5235C7.12323 12.3834 7.04682 12.1956 7.04682 12C7.04682 11.8044 7.12323 11.6166 7.25975 11.4765L15.0327 3.501C15.0963 3.43569 15.1724 3.38377 15.2564 3.34833C15.3403 3.31288 15.4306 3.29462 15.5217 3.29462C15.6129 3.29462 15.7031 3.31288 15.7871 3.34833C15.8711 3.38377 15.9472 3.43569 16.0107 3.501V3.4995Z"
                        fill="#F22161"
                      />
                    </svg>
                  </div>
                  <div class="swiper-button-next tw-cursor-pointer tw-rounded-full tw-bg-white tw-p-4">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.98925 3.4995C7.85841 3.63344 7.78516 3.81326 7.78516 4.0005C7.78516 4.18775 7.85841 4.36756 7.98925 4.5015L15.2988 12L7.98925 19.497C7.85841 19.6309 7.78516 19.8108 7.78516 19.998C7.78516 20.1852 7.85841 20.3651 7.98925 20.499C8.05285 20.5643 8.12888 20.6162 8.21287 20.6517C8.29686 20.6871 8.38709 20.7054 8.47825 20.7054C8.56941 20.7054 8.65965 20.6871 8.74364 20.6517C8.82763 20.6162 8.90366 20.5643 8.96725 20.499L16.7403 12.5235C16.8768 12.3834 16.9532 12.1956 16.9532 12C16.9532 11.8044 16.8768 11.6166 16.7403 11.4765L8.96725 3.501C8.90366 3.43569 8.82763 3.38377 8.74364 3.34833C8.65965 3.31288 8.56941 3.29462 8.47825 3.29462C8.38709 3.29462 8.29686 3.31288 8.21287 3.34833C8.12888 3.38377 8.05285 3.43569 7.98925 3.501V3.4995Z"
                        fill="#F22161"
                      />
                    </svg>
                  </div>
                </div>
              </Swiper>
            </div>
            <!-- GALLERY END -->
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="property"
      class="n-section-primary !tw-pb-10 !tw-pt-5 lg:tw-hidden xl:!tw-pb-14"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <MotionGroup is="div" class="tw-flex tw-flex-col" preset="fadeVisible" :duration="700">
        <div
          class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between tw-px-4 tw-py-6 lg:tw-items-start lg:tw-p-8"
        >
          <div
            class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7"
            :class="property.is_locked ? 'lg:!tw-col-span-12 xl:!tw-col-span-7' : ''"
          >
            <h2 class="n-title-primary tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>

            <div class="tw-mt-6">
              <p v-if="property.price.type.name" class="tw-mb-0">
                {{ property.price.type.name }}
              </p>
              <h4>{{ property.price.price }}</h4>
            </div>

            <div class="tw-mt-5 tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="black"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="black"
                />
              </svg>
              <small>{{ property.display_address }}</small>
            </div>

            <div v-if="!property.is_locked" class="tw-mt-6 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
              <div v-if="property.bedroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 19V13C2 12.55 2.09167 12.1417 2.275 11.775C2.45833 11.4083 2.7 11.0833 3 10.8V8C3 7.16667 3.29167 6.45833 3.875 5.875C4.45833 5.29167 5.16667 5 6 5H10C10.3833 5 10.7417 5.071 11.075 5.213C11.4083 5.355 11.7167 5.55067 12 5.8C12.2833 5.55 12.5917 5.35433 12.925 5.213C13.2583 5.07167 13.6167 5.00067 14 5H18C18.8333 5 19.5417 5.29167 20.125 5.875C20.7083 6.45833 21 7.16667 21 8V10.8C21.3 11.0833 21.5417 11.4083 21.725 11.775C21.9083 12.1417 22 12.55 22 13V19H20V17H4V19H2ZM13 10H19V8C19 7.71667 18.904 7.47933 18.712 7.288C18.52 7.09667 18.2827 7.00067 18 7H14C13.7167 7 13.4793 7.096 13.288 7.288C13.0967 7.48 13.0007 7.71733 13 8V10ZM5 10H11V8C11 7.71667 10.904 7.47933 10.712 7.288C10.52 7.09667 10.2827 7.00067 10 7H6C5.71667 7 5.47933 7.096 5.288 7.288C5.09667 7.48 5.00067 7.71733 5 8V10ZM4 15H20V13C20 12.7167 19.904 12.4793 19.712 12.288C19.52 12.0967 19.2827 12.0007 19 12H5C4.71667 12 4.47933 12.096 4.288 12.288C4.09667 12.48 4.00067 12.7173 4 13V15Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bedroom }} Beds</small
                >
              </div>
              <div v-if="property.bathroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V14C1.99996 14.9783 2.23913 15.9417 2.69665 16.8064C3.15417 17.671 3.81618 18.4107 4.625 18.961L4.293 19.293C4.19749 19.3852 4.12131 19.4956 4.0689 19.6176C4.01649 19.7396 3.9889 19.8708 3.98775 20.0036C3.9866 20.1364 4.0119 20.2681 4.06218 20.391C4.11246 20.5138 4.18671 20.6255 4.2806 20.7194C4.3745 20.8133 4.48615 20.8875 4.60905 20.9378C4.73194 20.9881 4.86362 21.0134 4.9964 21.0123C5.12918 21.0111 5.2604 20.9835 5.3824 20.9311C5.50441 20.8787 5.61475 20.8025 5.707 20.707L6.583 19.832C7.037 19.942 7.512 20 8 20H16C16.488 20 16.963 19.942 17.417 19.832L18.293 20.707C18.4816 20.8892 18.7342 20.99 18.9964 20.9877C19.2586 20.9854 19.5094 20.8802 19.6948 20.6948C19.8802 20.5094 19.9854 20.2586 19.9877 19.9964C19.99 19.7342 19.8892 19.4816 19.707 19.293L19.375 18.961C20.1838 18.4107 20.8458 17.671 21.3034 16.8064C21.7609 15.9417 22 14.9783 22 14V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H7V6ZM4 13H20V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V13Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bathroom }} Baths</small
                >
              </div>
              <div v-if="property.reception">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.556 18H18.444C19.3871 18 20.2916 17.6254 20.9585 16.9585C21.6254 16.2916 22 15.3871 22 14.444V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 10 20 10C19.4696 10 18.9609 10.2107 18.5858 10.5858C18.2107 10.9609 18 11.4696 18 12V13.2C18 13.4122 17.9157 13.6157 17.7657 13.7657C17.6157 13.9157 17.4122 14 17.2 14H6.8C6.58783 14 6.38434 13.9157 6.23431 13.7657C6.08429 13.6157 6 13.4122 6 13.2V12C6 11.4696 5.78929 10.9609 5.41421 10.5858C5.03914 10.2107 4.53043 10 4 10C3.46957 10 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V14.444C2 15.3871 2.37465 16.2916 3.04153 16.9585C3.70841 17.6254 4.61289 18 5.556 18Z"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path
                        d="M20 10C20 9.07 20 8.606 19.923 8.22C19.7687 7.44401 19.3877 6.73121 18.8282 6.17175C18.2688 5.6123 17.556 5.23132 16.78 5.077C16.394 5 15.93 5 15 5H9C8.07 5 7.606 5 7.22 5.077C6.44401 5.23132 5.73121 5.6123 5.17175 6.17175C4.6123 6.73121 4.23132 7.44401 4.077 8.22C4 8.606 4 9.07 4 10"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path d="M20 19V18M4 19V18" stroke="#074873" stroke-width="2" stroke-linecap="round" />
                    </svg> </span
                  >{{ property.reception }} Reception</small
                >
              </div>
              <div v-if="property.floor_area">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V5C21 3.897 20.103 3 19 3H5C3.897 3 3 3.897 3 5ZM19.002 19H5V5H19L19.002 19Z"
                        fill="#074873"
                      />
                      <path d="M15 12H17V7H12V9H15V12ZM12 15H9V12H7V17H12V15Z" fill="#074873" />
                    </svg> </span
                  >{{ property.floor_area }}</small
                >
              </div>
            </div>
          </div>
          <div
            v-if="!property.is_locked"
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-pt-0"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between md:tw-justify-start md:tw-gap-3 lg:tw-justify-end lg:tw-gap-8"
            >
              <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
              <button class="n-secondary" @click="onShared()">SHARE</button>
            </div>
          </div>

          <template v-if="property.is_locked">
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-col-span-5 xl:tw-pt-0"
            >
              <library-login />
            </div>
          </template>
        </div>
      </MotionGroup>
    </section>

    <section
      v-if="!property.is_locked"
      class="n-section-primary !tw-pt-0"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
          <!-- Property Detail -->
          <div class="tw-flex tw-flex-col tw-gap-16">
            <!-- Features -->
            <MotionGroup
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
              preset="fadeVisible"
              :duration="800"
              is="div"
            >
              <h3 class="n-title-primary !tw-opacity-100">Features</h3>
              <div class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <library-text class="tw-text-base" :text="feature"> </library-text>
                </div>
              </div>
            </MotionGroup>

            <!-- Floor Plan -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.floor_plans"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Floor Plans</h3>
              <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
            </MotionGroup>

            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property?.virtual_tour"
              id="matterport_video"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Matterport Video</h3>
              <library-iframe :src="matterPort" />
            </MotionGroup>

            <!-- Property Info -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.description"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Property Info</h3>
              <div
                class="tw-mb-4 tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
              >
                <div v-for="criteria in property.criteria_list" :key="criteria.id" class="tw-flex tw-gap-4 tw-p-4">
                  <span v-if="criteria.title === 'Parking'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Sewerage'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Water'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <span v-else>
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_481_37820)">
                        <path
                          d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                          fill="var(--c-primary)"
                        />
                        <path
                          d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                          fill="var(--c-primary)"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_481_37820">
                          <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <div>
                    <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                    <p>{{ criteria.value }}</p>
                  </div>
                </div>
              </div>
              <div v-html="property.description" style="font-weight: 300 !important"></div>
            </MotionGroup>

            <!-- Map -->
            <div
              v-if="property.map_position && property.map_position.lat && property.map_position.lng"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Map</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <neuron-google-map
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </MotionGroup>
            </div>

            <!-- EPC -->
            <div
              v-if="property?.epcs.length > 0"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">EPC</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <epc :data="property.epcs" :component="component" />
              </MotionGroup>
            </div>
          </div>
        </div>

        <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
          <div v-if="sidebarComponents && sidebarComponents.length">
            <div
              v-if="property?.featured_video"
              class="tw-mb-5 tw-flex tw-w-full tw-flex-col tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-col-span-12 tw-pb-8">Walkthrough Video</h3>
              <div
                class="video-landscape tw-col-span-12 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
                style="border-radius: var(--rounded)"
              >
                <library-iframe
                  :src="propertyVideo(property?.featured_video.mediaLink)"
                  :w-ratio="9"
                  :h-ratio="16"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </div>
            </div>
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
      </div>
      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme5/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme5/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'Theme5PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: 'features',
      swiper: {},
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      virtualTourPopupConfig: {
        isActive: false,
      },
      videoTourPopupConfig: {
        isActive: false,
      },
    };
  },

  computed: {
    markerColor() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primarySevenPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 7);
      }
      return [];
    },

    allPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, this.property.medias.length);
      }
      return [];
    },

    primaryFourPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    matterPort() {
      let mediaLink = this.property?.virtual_tour?.mediaLink;
      if (mediaLink && mediaLink.includes('youtu')) {
        return null;
      }
      if (mediaLink && mediaLink.startsWith('http://')) {
        mediaLink = mediaLink.replace('http://', 'https://');
      }
      return mediaLink;
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),

    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    onSwiper(swiper: any) {
      this.swiper = swiper;
    },

    propertyVideo(videoLink: string) {
      if (videoLink) {
        // Check if the link is already an embed link
        if (!videoLink.includes('embed')) {
          // Convert the standard YouTube link to an embed link
          let videoId = videoLink.split('v=')[1];
          if (videoId) {
            const ampersandPosition = videoId.indexOf('&');
            if (ampersandPosition !== -1) {
              videoId = videoId.substring(0, ampersandPosition);
            }
            videoLink = `https://www.youtube.com/embed/${videoId}`;
          }
        }

        return videoLink;
      }

      return null;
    },

    showVideoTourPopup() {
      this.virtualTourPopupConfig.isActive = true;
    },

    showVideoTourPopup2() {
      this.videoTourPopupConfig.isActive = true;
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 44px;
  height: 64px;
  background-color: #fff;
  border-radius: var(--rounded);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card) {
  width: 100% !important;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card figure) {
  border: none !important;
}

::v-deep(.floor-tab) {
  padding: unset !important;
}

::v-deep(.inline-iframe-container iframe) {
  height: 590px;
}

.video-landscape ::v-deep(.video) {
  height: 100%;
  min-height: unset !important;
}

.theme4-floor-plan ::v-deep(figure) {
  height: unset !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}

::v-deep(img) {
  border-radius: 4px;
}

.n-primary:hover svg path {
  fill: var(--c-primary);
}

::v-deep(#login) {
  @apply tw-col-span-12 xl:tw-col-span-5;
}

@media (min-width: 1280px) {
  ::v-deep(#send-link-button) {
    margin-top: -52px;
  }
}

@media (min-width: 1540px) {
  ::v-deep(#send-link-button) {
    margin-top: -24px;
  }
}
</style>
